import React from "react";
import { Bar } from "react-chartjs-2";
import styled from "styled-components";
import { colors as hoverColors } from "../utils";

const colors = hoverColors.map(e => `${e}AA`);

const Container = styled.div`
  height: auto;
  max-width: 35rem;
  margin: auto;
`;

const AgeChart = ({ data }) => {
  return (
    <Container>
      <Bar
        data={{
          labels: data.map(({ name }) => name),
          datasets: [
            {
              data: data.map(({ value }) => value),
              backgroundColor: colors,
              hoverBackgroundColor: hoverColors
            }
          ]
        }}
        options={{
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                gridlines: {
                  display: false
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ]
          }
        }}
      />
    </Container>
  );
};

export default AgeChart;
